import TextTip from './TextTip';

export default TextTip;
